import { Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-sectores-productivos',
  templateUrl: './sectores-productivos.component.html',
  styleUrls: ['./sectores-productivos.component.css']
})
export class SectoresProductivosComponent implements OnInit {

  secProd: boolean;
  botones: boolean;
  subSect: boolean;
  idSect: number;
  desc: string;

  subSectEs: boolean;
  estandar: boolean;
  estandarNB: string;
  listEstandar: boolean;
  estandarHeade:boolean;
  esmarca:boolean;

  padre: number;
  titlePadre: string;
  desEstandar:boolean;
  desEstandarMarca:boolean;
  codigoEC:string;
  tablaEstandar:boolean;
  marca:boolean;
  trasnversal:boolean;
  
  estandarDes: string;

  constructor() {
    this.secProd = false;
    this.botones = false;
    this.subSect = false;
    this.subSectEs = true;
    this.estandar = false;
    this.listEstandar = false;
    this.idSect = 0;
    this.desc = 'Sectores Productivos';
    this.estandarNB = 'Estándares Por Sector Productivo';
    this.padre = 0;
    this.desEstandar=false;
    this.tablaEstandar=false;
    this.desEstandarMarca=false;
    this.esmarca=false;
    this.marca=false;
    this.trasnversal=false;
    this.estandarDes='';
  }

  ngOnInit(): void {
    
  }

  onSectores() {
    this.botones = false;
    this.secProd = true;
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = false;
    this.desEstandar=false;
    this.desEstandarMarca=false;
    this.marca=false;
    
  }

  estandares() {
    this.botones = false;
    this.secProd = false;
    this.subSectEs = true;
    this.estandar = false;
    this.listEstandar = false;
    this.estandarHeade=true;
    this.desEstandar=false;
    this.desEstandarMarca=false;
    this.marca=false;
  }

  onSectorById(event) {
    this.secProd = false;
    this.subSect = true;
    this.listEstandar = false;
    this.idSect = event.tipo;
    this.desc = event.descripcion;
    this.subSectEs = false;
    this.estandar = false;
    this.desEstandar=false;
    this.desEstandarMarca=false;
    this.marca=false;
  }

  onBack(event) {
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = false;
    if (event === 0) {
      this.secProd = false;
    } else {
      this.desc = 'Sectores Productivos';
      this.subSect = false;
      this.secProd = true;
      this.marca=false;
    }
  }

  estandarOnBack(event) {
    this.estandarDes = '';
    this.subSect = false;
    this.secProd = false;
    this.listEstandar = false;
    if (event === 0) {
      this.subSectEs = false;
    } else {
      this.estandarNB = 'Sectores Productivos';
      this.estandar = false;
      this.subSectEs = true;
      this.desEstandar=false;
      this.marca=false;
    }
  }

  estandarMarcaOnBack(event) {

    if (event === 0) {
    this.listEstandar = false;
      this.secProd = false;
      this.botones = false;
      this.subSect = false;
      this.subSectEs = true;
      this.estandar = false;
      this.listEstandar = false;
      this.idSect = 0;
      this.desc = 'Sectores Productivos';
      this.estandarNB = 'Estándares Por Sector Productivo';
      this.padre = 0;
      this.desEstandar=false;
      this.tablaEstandar=false;
      this.desEstandarMarca=false;
      this.esmarca=false;
      this.marca=false;
    } 
    else{
      this.secProd = false;
    this.subSect = false;
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = false;
    this.desEstandar=false;
    this.desEstandarMarca=false;
     this.tablaEstandar=false;
     this.esmarca=true;
     this.marca=true;
    }
      
    
  }

  onSectorEsById(event) {
 
    if (event.element==21){
      this.secProd = false;
      this.subSect = false;
      this.subSectEs = false;
      this.estandar =false;
      this.listEstandar = false;
      this.desEstandar=false;
      this.tablaEstandar=false;
      this.desEstandarMarca=false;
      this.marca=false;
      this.trasnversal=true;
    }else{
    this.secProd = false;
    this.subSect = false;
    this.idSect = event.element.tipo;
    this.estandarNB = event.element.descripcion;
    this.padre =  event.padre
    this.subSectEs = false;
    this.estandar = true;
    this.listEstandar = false;
    this.desEstandar=false;
    this.tablaEstandar=true;
    this.desEstandarMarca=false;
    this.marca=false;
    }
  

  }

  onEstandarBySector(event){
    this.secProd = false;
    this.subSect = false;
    this.idSect = event.element.tipo;
    this.estandarNB = event.element.descripcion;
    this.padre =  event.padre;
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = true;
    this.desEstandar=false;
    this.desEstandarMarca=false;
    this.titlePadre = event.titlePadre;
    this.marca=false;
    
  }

  onDeesEstandarBySector(event){
    this.secProd = false;
    this.subSect = false;
    this.idSect = event.idselectorRes;
    this.estandarNB = event.element.descripcion;
    this.padre =  event.padre;
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = false;
    this.desEstandar=true;
    this.desEstandarMarca=false;
    this.titlePadre = event.titlePadre;
    this.codigoEC=event.element.codigoEC;
    this.esmarca=false;
    this.marca=false;

  }

  onDeesEstandarMarcaBySector(event){
   
    this.secProd = false;
    this.subSect = false;
    this.estandarNB = event.titlePadre;
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = false;
    this.desEstandar=false;
    this.desEstandarMarca=true;
    this.titlePadre = event.titlePadre;
    this.codigoEC=event.padre;
     this.tablaEstandar=false;
     this.esmarca=false;
     this.marca=false;

  }

  onTablaEstandaresMarca(event){
    this.secProd = false;
    this.subSect = false;
    this.estandarNB = event.marca;
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = false;
    this.desEstandar=false;
    this.desEstandarMarca=false;
    this.esmarca=true;
    this.titlePadre = event;
    this.codigoEC=event;
    this.marca=true;

  }

  onBackSubsec(event){
    this.secProd = false;
    this.subSect = false;
    this.idSect = event;
    this.estandarNB = '';
    this.subSectEs = false;
    this.estandar = true;
    this.listEstandar = false;
    this.desEstandar=false;
    this.estandarNB =  this.titlePadre 
  }

  onBackEstandare(event){
    this.secProd = false;
    this.subSect = false;
    this.idSect = event;
    this.estandarNB = '';
    this.subSectEs = false;
    this.estandar = false;
    this.listEstandar = true;
    this.desEstandar=false;
    this.estandarNB =  this.titlePadre
  }

  setEstandar(event){
    this.estandarDes = event;
  }

}


